import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { USER } from 'sh-www/models/user';
import SellerOnlyRouteMixin from 'sh-www/mixins/seller-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

const QUERY_PARAMS = ['sort', 'secondary_sort', 'filter', 'search'].reduce((accum, param) => {
  accum[param] = { refreshModel: true, replace: true };
  return accum;
}, { });

/**
 * @param {string} path
 * @returns {{new(): SellerProjectsViewRoute, prototype: SellerProjectsViewRoute}}
 */
export const sellerProjectsViewRouteFactory = (path) => {
  return class SellerProjectsViewRoute extends Route.extend(SellerOnlyRouteMixin) {
    get queryParams() {
      return QUERY_PARAMS;
    }

    get templateName() {
      return 'projects.seller-results';
    }

    /**
     * dummy model required, otherwise `refreshModel: true` will not trigger lifecycle
     * methods on param update
     */
    model() {
      return { };
    }

    /** @inheritDoc */
    setupController(controller, _, transition) {
      super.setupController(...arguments);

      const { queryParams } = transition.to;

      if (!controller.modelIsValid(queryParams)) {
        controller.reloadModel.perform(queryParams);
      }
    }

    activate(transition) {
      super.activate(...arguments);
      trackPageViewFromTransition(this, transition, path);
    }
  };
};

class ProjectsIndexRoute extends Route {
  @service session;
  @service router;

  redirect() {
    switch (this.session.currentUser.type) {
      case USER.TYPES.BUYER:
        this.router.replaceWith('projects.in-progress');
        break;

      case USER.TYPES.SELLER:
        this.router.replaceWith('projects.active');
        break;

      case USER.TYPES.ADMIN:
        this.router.replaceWith('admin.projects');
        break;

      default:
        this.router.replaceWith('start');
        break;
    }
  }
}

export default ProjectsIndexRoute;
